import {handleActions} from 'redux-actions';

import {DISPLAY_LOGIN_LOADING, HIDE_LOGIN_LOADING} from '/enum/loading.enum';
import {withPayload} from '/util/reducer.util';

import displayLoginLoading from './loading/displayLoginLoading';
import hideLoginLoading from './loading/hideLoginLoading';

const initialState = {
  loginLoading: false,
};

export default handleActions(
  {
    [DISPLAY_LOGIN_LOADING]: withPayload(displayLoginLoading),
    [HIDE_LOGIN_LOADING]: withPayload(hideLoginLoading),
  },
  initialState,
);
